import type { ReactElement } from 'react';
import React from 'react';
import styled, { css } from 'styled-components';
import { Radio, spacingHelper } from '@construct-kit/core';
import type { FilterOptionType } from '../../../../shared/model/constants/filterTypes';
import { FilterWrapper } from './FilterWrapper';
import type { TenureType } from '../../../../shared/model/tsTypes';

export type TenureTypesFilterProps = {
  options: FilterOptionType[];
  value: TenureType['key'];
  onChange: (newValue: TenureType['key']) => void;
};

const StyledRadios = styled.div`
  ${({ theme }) => css`
    ${theme.layoutBreakpoints.large} {
      display: grid;
      grid-template-columns: repeat(2, minmax(0, 1fr));
      column-gap: ${spacingHelper('medium')};
    }
  `}
`;

const StyledRadio = styled(Radio)`
  margin-top: ${spacingHelper('large')};
`;

export const TenureTypesFilter = ({
  options,
  value,
  onChange,
}: TenureTypesFilterProps): ReactElement => {
  const optValues = options.map((opt) => opt.value);

  const handleOnOptionSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const optValue = event.target.value;
    if (optValues.includes(optValue)) {
      onChange(optValue);
    }
  };

  return (
    <FilterWrapper title="Tenure type">
      <StyledRadios>
        {options.map(
          (opt: FilterOptionType): ReactElement => (
            <StyledRadio
              key={opt.value}
              label={opt.label}
              value={opt.value}
              name="tenure-type"
              onChange={handleOnOptionSelect}
              checked={opt.value === value}
              sizeVariant="large"
            />
          ),
        )}
      </StyledRadios>
    </FilterWrapper>
  );
};
